/**
 * 
 * @param arg1 
 * @param arg2 
 * @returns 加法
 */
export const mathPlus = (arg1, arg2) => {
    let r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length; // 获取小数点后字符长度
    } catch (error) {
        r1 = 0; // 为整数状态，r1赋0
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (error) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); // 确保所有参数都为整数
    return (arg1 * m + arg2 * m) / m;
}

/**
 * 
 * @param arg1 
 * @param arg2 
 * @returns 减法
 */
export const mathSubtract = (arg1, arg2) => {
    let r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (error) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (error) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return ((arg1 * m - arg2 * m) / m);
}

/**
 * 
 * @param arg1 
 * @param arg2 
 * @returns 乘法
 */
export const mathMultiply = (arg1, arg2) => {
    let m = 0;
    let s1 = arg1.toString();
    let s2 = arg2.toString();
    try {
        m += s1.split('.')[1].length; // 小数相乘，小数点后个数相加
    } catch (e) { }
    try {
        m += s2.split('.')[1].length;
    } catch (e) { }
    return (
        (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
        Math.pow(10, m)
    );
}

/**
 * 
 * @param arg1 
 * @param arg2 
 * @returns 除法
 */
export const mathDivide = (arg1, arg2) => {
    if( arg2 === 0 ) {
        return 0
    }
    let m1 = 0;
    let m2 = 0;
    let n1 = 0;
    let n2 = 0;
    try {
        m1 = arg1.toString().split('.')[1].length;
    } catch (e) { }
    try {
        m2 = arg2.toString().split('.')[1].length;
    } catch (e) { }
    n1 = Number(arg1.toString().replace('.', ''));
    n2 = Number(arg2.toString().replace('.', ''));
    /**
    * 将除法转换成乘法
    * 乘以它们的小数点后个数差
    */
    return mathMultiply(n1 / n2, Math.pow(10, m2 - m1));
}